import React, { useState } from 'react';
import { bool, number } from 'prop-types';

import { ALERT_TYPE, ESTADOS_FIRMA, REQUEST_METHOD, ShowToastMessage } from '@laramie/ui';
import { APIS } from '../../../config/apis';
import { standardRequest } from "../../../utils/requests"
import { SolicitudFirmaModal } from '../../common';
import { useManagedContext, useNav } from '../../hooks';


const FirmaDigitalAction = (props) => {

    //hooks
    const { setIsLoading } = useManagedContext()
    const navigate = useNav()

    const [showModal, setShowModal] = useState(false)
    const [data, setData] = useState({})

    //function
    const FindFirmaDigital = () => {
        setIsLoading(true)
        standardRequest(REQUEST_METHOD.GET, `${APIS.URLS.FIRMA_DIGITAL}/${props.idFirmaDigital}`)
        .then(data => {
            if (data.fechaSolicitud) data.fechaSolicitud = new Date(data.fechaSolicitud);
            if (data.fechaFirma) data.fechaFirma = new Date(data.fechaFirma);
            setShowModal(true)
            setData(data)
        })
        .catch(error => {}) //excepcion administrada en standardRequest
        .finally(() => setIsLoading(false))
    }

    const SolicitudFirmaDigital = () => {
        setIsLoading(true)
        standardRequest(REQUEST_METHOD.PUT, `${APIS.URLS.FIRMA_DIGITAL}/tipo-firma/${props.idTipoFirma}`, { idEntidad: props.idEntidad })
        .then(data => {
            ShowToastMessage(ALERT_TYPE.ALERT_SUCCESS, "Solicitud de firma digital enviada correctamente")
            navigate({ to: 0 })
        })
        .catch(error => {}) //excepcion administrada en standardRequest
        .finally(() => setIsLoading(false))
    }

    const GetEstadoIcon = () => {
        return  (props.idEstadoFirma === ESTADOS_FIRMA.PENDIENTE) ? 'clock_loader_60' :
                (props.idEstadoFirma === ESTADOS_FIRMA.RECHAZADO) ? 'close' :
                (props.idEstadoFirma === ESTADOS_FIRMA.FIRMADO) ? 'check' : '';
    }
    const GetEstadoTitle = () => {
        return  (props.idEstadoFirma === ESTADOS_FIRMA.PENDIENTE) ? 'pendiente' :
                (props.idEstadoFirma === ESTADOS_FIRMA.RECHAZADO) ? 'rechazado' :
                (props.idEstadoFirma === ESTADOS_FIRMA.FIRMADO) ? 'firmado' : '';  
    }

    const showSolicitudButton = !props.disabled && (!props.idEstadoFirma || props.idEstadoFirma === ESTADOS_FIRMA.RECHAZADO)

    return (
        <>
            {showModal && <SolicitudFirmaModal data={data} onDismiss={() => setShowModal(false)} />}

            <div className='footer-icon-container-isolation'>
                {props.idEstadoFirma && (
                    <div className='footer-icon-container'>
                        <button className="btn btn-i-task m-left-10" onClick={FindFirmaDigital}>
                            <span className="material-symbols-outlined" title="Ver">search</span>
                        </button>
                        <span className="material-symbols-outlined btn-i-task m-left-10 i-disabled" title={GetEstadoTitle()}>{GetEstadoIcon()}</span>
                        
                    </div>
                )}
                {showSolicitudButton && (
                    <div className={`footer-icon-container${props.idEstadoFirma && showSolicitudButton ? ' vertical' : ''}`}>
                        <button className="btn btn-i-task m-left-10" onClick={FindFirmaDigital}>
                            <span className="material-symbols-outlined" title="solicitar firma digital" onClick={SolicitudFirmaDigital}>stylus</span>
                        </button>
                    </div>
                )}
            </div>
        </>
    );
}

FirmaDigitalAction.propTypes = {
    idEntidad: number,
    idTipoFirma: number,
    idFirmaDigital: number,
    idEstadoFirma: number,
    disabled: bool
};
  
  FirmaDigitalAction.defaultProps = {
    idEntidad: null,
    idTipoFirma: null,
    idFirmaDigital: null,
    idEstadoFirma: null,
    disabled: false
};
  
export default FirmaDigitalAction;
